import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, FormControlLabel } from '@mui/material';
import styled from '@emotion/styled';
import colors from 'styles/colors';

const LineBreak = styled.hr`
  flex-basis: 100%;
  height: 0;
  margin: 4px 0;
  border: 0;
`;

const Wrapper = styled.label`
  display: inline-flex;
  margin-right: 8px;
  margin-bottom: 4px;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};

  /* tighten default spacing a bit */
  .MuiFormControlLabel-root {
    margin-left: 0;
    margin-right: 0;
  }

  /* keep label wrapping like your Chip */
  .MuiFormControlLabel-label {
    white-space: normal;
  }

  /* color system consistent with project */
  .MuiCheckbox-root.Mui-checked {
    color: ${colors.primary};
  }
  .MuiCheckbox-root:not(.Mui-checked):hover {
    background-color: transparent; /* avoid MUI hover gray if you prefer a clean look */
  }
`;

const CheckboxItem = ({
  name,
  label,
  checked,
  showOnNewLine = false,
  disabled = false,
  onChange, // (boolean) => void
}) => (
  <>
    {showOnNewLine && <LineBreak />}
    <Wrapper disabled={disabled}>
      <FormControlLabel
        control={
          <Checkbox
            size="small"
            checked={!!checked}
            onChange={(e) => onChange(e.target.checked)}
            disabled={disabled}
            name={name}
          />
        }
        label={label}
      />
    </Wrapper>
  </>
);

CheckboxItem.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  showOnNewLine: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

export default CheckboxItem;
